module.exports = "/assets/scripts/apps/overlays/1.11/img/sailing.svg";